import { useTutorialContext } from 'context/TutorialContext';
import { flushSync } from 'react-dom';
import styled from 'styled-components';

export const BookingStatusesGuideButton = () => {
  const {
    bookingProcessModalVisibility,
    setBookingProcessTutorialExperienceTrigger,
  } = useTutorialContext();

  const onClick = () => {
    flushSync(() => {
      setBookingProcessTutorialExperienceTrigger('manual');
    });

    bookingProcessModalVisibility.showModal();
  };

  return (
    <StyledButton type='button' onClick={onClick}>
      Booking Statuses Guide
    </StyledButton>
  );
};

const StyledButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${({ theme }) => theme.palette.primary[0]};
  white-space: nowrap;
`;
